import React from 'react';
import { IconProp, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/pro-solid-svg-icons';

library.add(fas);

interface ActivityIconProps {
  item: MedScout.ActivityType;
  height?: string;
  width?: string;
  iconSize?: string;
}

const ActivityIcon = ({ ...props }: ActivityIconProps) => {
  const {
    item,
    height = '32px', // specific to keep the icon size consistent
    width = '32px',
    iconSize = '0.875rem',
  } = props;

  library.add(fas);

  const bgColor = item?.color ? `#${item.color}20` : '#00000020';

  return (
    <div
      className="flex justify-center items-center rounded-full bg-white relative before:content-[''] before:absolute before:rounded-full before:z-[2]"
      style={{
        width,
        height,
        color: item?.color ? `#${item.color}` : 'inherit',
      }}
    >
      <div
        className="absolute rounded-full z-[2]"
        style={{
          width,
          height,
          backgroundColor: bgColor,
        }}
      />
      <Icon
        icon={(item?.icon as IconProp) || 'bolt'}
        style={{
          width: iconSize,
          height: iconSize,
          color: item?.color ? `#${item.color}` : '#000000',
          position: 'relative',
          zIndex: 3, // Ensure it is above the mask
        }}
      />
    </div>
  );
};

export default ActivityIcon;
